import { mapActions, mapGetters } from 'vuex';

import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';

export default {
  REQUEST_LIFECYCLE,
  computed: {
    ...mapGetters('dashboard/pointsBalance', [
      'currentPointsBalanceMeta',
      'currentRawPointsBalance',
    ]),
  },
  methods: {
    ...mapActions('dashboard/pointsBalance', [
      'fetchPointsBalance',
    ]),
  },
};
